import { fmtCurrency } from "../../lib/format";

function BreakdownList({ title, items, total, accent }) {
  const max = Math.max(...items.map((i) => Math.abs(i.value)), 1);
  return (
    <div className="bg-brand-surface border border-brand-border p-6" data-testid={`breakdown-${title.toLowerCase().replace(/\s/g, "-")}`}>
      <div className="flex items-baseline justify-between">
        <p className="text-xs uppercase tracking-[0.15em] text-brand-tertiary">{title}</p>
        <p className="font-mono text-sm text-brand-ink">{fmtCurrency(total)}</p>
      </div>
      <div className="mt-6 space-y-4">
        {items.length === 0 && <p className="text-sm text-brand-tertiary">No data for this period.</p>}
        {items.map((it) => (
          <div key={it.key}>
            <div className="flex items-baseline justify-between text-sm">
              <span className="text-brand-muted">{it.label}</span>
              <span className="font-mono text-brand-ink">{fmtCurrency(it.value)}</span>
            </div>
            <div className="mt-1.5 h-1.5 w-full bg-brand-hover overflow-hidden">
              <div className="h-full transition-all duration-500" style={{ width: `${(Math.abs(it.value) / max) * 100}%`, backgroundColor: accent }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function Breakdowns({ summary }) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <BreakdownList title="Revenue Breakdown" items={summary.revenue_breakdown} total={summary.totals.total_revenue} accent="#1E3A2F" />
      <BreakdownList title="Expense Breakdown" items={summary.expense_breakdown} total={summary.totals.total_expenses} accent="#A96147" />
    </div>
  );
}
